let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eYMQP")).then(() => parcelRequire('dx1U6'));